import Text from '../../components/Text';
import { fontSizes } from '../../constants/constants';
import subscribeFunctional from './index.function';
import { Formik } from 'formik';
import CustomInput from '../../components/CustomInput';
import ViewReverse from '../../components/ViewReverse';
import ErrorText from '../../components/ErrorText';
import Button from '../../components/Button';
import CustomModal from '../../components/CustomModal';
import dayjs from 'dayjs';
import LoaderModal from '../../components/LoaderModal';
import CustomDropdown from '../../components/CustomDropdown';
import {
  sell_order_schema,
  sell_order_validation_schema,
} from '../../validations_schemas/sell_order_validation_schema';
import { ReactSVG } from 'react-svg';
import icons from '../../constants/icons';
import Loader from '../../components/Loader';
import ViewItems from '../../components/ViewItems';
import { cn, formatNumbers } from '../../utils/utils';
import { integer_regex } from '../../utils/functions';

const InternalUnitExchange = () => {
  const {
    sellClientHoldingFunds,
    orderData,
    TextWeight,
    fund_loading,
    getContentKey,
    onVerify,
    reviewModal,
    setReviewModal,
    toogleReviewModal,
    handleReviewOrder,
    fund_document_loading,
    navigate,
    dispatch,
    getSellOrderClientHoldingOfSelectedFund,
    sellOrderClientHoldingOfSelectedFund,
    setSellOrderClientHoldingOfSelectedFund,
    isArabic,
    direction,
    user,
  } = subscribeFunctional();

  return (
    <div className='min-h-full'>
      <ViewReverse className={'gap-5 items-center'}>
        <ReactSVG
          src={icons?.backSmall}
          className={`cursor-pointer ${isArabic ? 'rotate-180' : ''}`}
          onClick={() => navigate(-1)}
        />
        <Text
          text={getContentKey('heading')}
          color='text-black'
          size={fontSizes.h18}
          weight={TextWeight.bold}
        />
      </ViewReverse>
      <div className='border border-grey rounded-xl mt-8 py-5 px-5 shadow-light'>
        <Formik
          validationSchema={sell_order_validation_schema}
          initialValues={sell_order_schema}
          validateOnChange={false}
          validateOnMount={false}
          validateOnBlur={false}
          onSubmit={(values, functions) =>
            handleReviewOrder(values, functions?.resetForm)
          }
        >
          {({
            handleSubmit,
            setFieldValue,
            setFieldError,
            values,
            errors,
            resetForm,
          }) => {
            const is_valid = values?.amount && values?.fundName;

            return (
              <div className='mt-2'>
                <ViewReverse>
                  <div className='w-full sm:w-1/2'>
                    <CustomDropdown
                      label={getContentKey('fund_sar')}
                      selectedValue={values?.fundName}
                      valueKey={'fundName'}
                      options={sellClientHoldingFunds?.fundMaster}
                      onSelect={(val) => {
                        setFieldValue('fundName', val);
                        dispatch(
                          getSellOrderClientHoldingOfSelectedFund(`${val?.fundId}?investorTypeId=${user?.investorTypeId}`)
                        );
                      }}
                      isRequired={true}
                    />
                  </div>
                </ViewReverse>

                <ViewReverse>
                  <div className='w-full sm:w-1/2 pt-2 sm:pt-4'>
                    <CustomInput
                      label={getContentKey('label_unit')}
                      placeholder={getContentKey('unit_placeholder')}
                      isRounded
                      type='text'
                      value={values.amount}
                      onChange={(e) => {
                        const amount = e.target.value;
                        if (amount === '' || integer_regex.test(amount)) {
                          setFieldValue('amount', amount);
                          setFieldError('amount', null);
                        }
                      }}
                      isError={errors?.amount}
                      isRequired
                    />
                  </div>
                </ViewReverse>
                <ErrorText text={getContentKey(errors?.amount)} />
                <div className='pt-3'>
                  <Text
                    text={getContentKey('applicable_transaction')}
                    weight={TextWeight.light}
                    isTruncate={false}
                  />
                </div>
                <div className='pt-3 sm:pt-5'>
                  <Text
                    text={getContentKey('available_units')}
                    size={fontSizes.h14}
                    color='text-primary'
                    weight={TextWeight.medium}
                  />
                  {fund_loading ? (
                    <div className={cn('flex', isArabic ? 'justify-end pr-8' : 'justify-start pl-8')}>
                      <Loader width={'w-5'} height={'h-5'} className='mx-0' />
                    </div>
                  ) : (
                    <Text
                      text={
                        values?.fundName ? formatNumbers(sellOrderClientHoldingOfSelectedFund?.availableHolding, 0) : 0
                      }
                      size={fontSizes.h26}
                      weight={TextWeight.medium}
                      color='text-black'
                    />
                  )}
                </div>

                <div className='border-t border-grey h-1 mt-3 w-full'></div>

                <ViewReverse className='gap-2 sm:gap-3 mt-2 sm:mt-4'>
                  <Button
                    text={getContentKey('review_btn')}
                    bgColor='bg-primary'
                    className={
                      'w-full sm:w-fit sm:px-10 rounded-lg capitalize py-2 text-center'
                    }
                    onClick={() => {
                      setFieldValue('is_submit', true);
                      handleSubmit();
                    }}
                    isDisabled={!is_valid || fund_loading}
                  />
                  <Button
                    text={getContentKey('clear_btn')}
                    bgColor='bg-white'
                    color='text-primary'
                    className={
                      'w-full sm:w-fit sm:px-16 rounded-lg capitalize py-2 text-center border border-primary'
                    }
                    onClick={() => {
                      resetForm()
                      dispatch(setSellOrderClientHoldingOfSelectedFund(null))
                    }}
                  />
                </ViewReverse>
              </div>
            );
          }}
        </Formik>
      </div>

      <CustomModal
        isOpen={reviewModal}
        heading={getContentKey('confirmation_heading')}
        isFullWidth
        onClose={toogleReviewModal}
        isCenter={false}
        color={'text-black'}
      >
        <Text
          text={getContentKey('order_summary')}
          color='text-text-grey/60'
          size={fontSizes.h14}
        />

        <ViewReverse
          className={'justify-between border-b py-2 border-b-grey mt-3'}
        >
          <Text text={getContentKey('fund')} size={fontSizes.h14} />
          <Text
            text={orderData?.fundName?.fundName}
            size={fontSizes.h14}
            color='text-primary'
            weight={TextWeight.semiBold}
          />
        </ViewReverse>

        <ViewReverse className={'justify-between border-b py-2 border-b-grey'}>
          <Text text={getContentKey('label_unit')} size={fontSizes.h14} />
          <ViewReverse>
            <Text
              text={formatNumbers(orderData?.amount, 0)}
              size={fontSizes.h14}
              color='text-primary'
              weight={TextWeight.semiBold}
            />
          </ViewReverse>
        </ViewReverse>
        <ViewReverse className={'justify-between border-b py-2 border-b-grey'}>
          <Text text={getContentKey('date')} size={fontSizes.h14} />
          <Text
            text={dayjs().format('DD MMM, YYYY')}
            size={fontSizes.h14}
            color='text-primary'
            weight={TextWeight.semiBold}
          />
        </ViewReverse>

        <ViewReverse className='items-center w-full justify-end gap-2 mt-3'>
          <Button
            text={getContentKey('review_btn')}
            bgColor='bg-primary'
            className={'w-full px-0 text-center border border-orange'}
            onClick={onVerify}
            loading={fund_loading}
          />
          <Button
            text={getContentKey('edit')}
            bgColor='bg-white'
            color='text-primary'
            className={
              'w-full rounded-lg capitalize py-2 text-center border border-primary'
            }
            onClick={() => {
              setReviewModal(false);
            }}
          />
        </ViewReverse>
      </CustomModal>

      <LoaderModal open={fund_document_loading} />
    </div>
  );
};

export default InternalUnitExchange;
